import { render, staticRenderFns } from "./OurAchievements.vue?vue&type=template&id=1dfa39aa&scoped=true"
import script from "./OurAchievements.vue?vue&type=script&lang=js"
export * from "./OurAchievements.vue?vue&type=script&lang=js"
import style0 from "./OurAchievements.vue?vue&type=style&index=0&id=1dfa39aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa39aa",
  null
  
)

export default component.exports